import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "message-me" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Message Me", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_BFormSelectOption = _resolveComponent("BFormSelectOption")!
  const _component_BFormSelect = _resolveComponent("BFormSelect")!
  const _component_BFormTextarea = _resolveComponent("BFormTextarea")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BFormGroup = _resolveComponent("BFormGroup")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_BContainer = _resolveComponent("BContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_BRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_BRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _createVNode(_component_BForm, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_BFormGroup, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_BRow, { class: "mb-1 mb-lg-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BCol, {
                              cols: "12",
                              lg: "4",
                              "offset-lg": "2",
                              class: "pe-lg-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BFormInput, {
                                  type: "text",
                                  placeholder: "Name",
                                  class: _normalizeClass(["message-me__input message-me__input--text", { 'is-invalid': _ctx.v$.form.name.$errors.length > 0 && _ctx.v$.form.name.$dirty }]),
                                  modelValue: _ctx.form.name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
                                }, null, 8, ["modelValue", "class"]),
                                (_ctx.v$.form.name.$errors.length > 0 && _ctx.v$.form.name.$dirty)
                                  ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                                      key: 0,
                                      class: "text-start py-1 px-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Name is required and must be at least 3 characters. ")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_BFormInput, {
                                  type: "email",
                                  placeholder: "Email Address",
                                  class: _normalizeClass(["message-me__input message-me__input--text", { 'is-invalid': _ctx.v$.form.email.$errors.length > 0 && _ctx.v$.form.email.$dirty }]),
                                  modelValue: _ctx.form.email,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event))
                                }, null, 8, ["modelValue", "class"]),
                                (_ctx.v$.form.email.$errors.length > 0 && _ctx.v$.form.email.$dirty)
                                  ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                                      key: 1,
                                      class: "text-start py-1 px-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Email is required and must be a valid address. ")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_BFormSelect, {
                                  class: _normalizeClass(["message-me__input message-me__input--select", { 'is-invalid': _ctx.v$.form.subject.$errors.length > 0 && _ctx.v$.form.subject.$dirty }]),
                                  modelValue: _ctx.form.subject,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.subject) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_BFormSelectOption, { value: "Project Enquiry" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Project Enquiry")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_BFormSelectOption, { value: "Feedback" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Feedback")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_BFormSelectOption, { value: "Other" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Other")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "class"]),
                                (_ctx.v$.form.subject.$errors.length > 0 && _ctx.v$.form.subject.$dirty)
                                  ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                                      key: 2,
                                      class: "text-start py-1 px-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Subject is required. ")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_BCol, {
                              cols: "12",
                              lg: "4",
                              class: "ps-lg-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BFormTextarea, {
                                  placeholder: "Your message...",
                                  class: _normalizeClass(["message-me__input message-me__input--textarea", { 'is-invalid': _ctx.v$.form.message.$errors.length > 0 && _ctx.v$.form.message.$dirty }]),
                                  modelValue: _ctx.form.message,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.message) = $event))
                                }, null, 8, ["modelValue", "class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_BRow, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_BCol, {
                              cols: "12",
                              lg: "4",
                              "offset-lg": "2",
                              class: "pt-1 pe-lg-0",
                              order: "2",
                              "order-lg": "1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BButton, {
                                  class: "w-100",
                                  squared: "",
                                  onClick: _ctx.resetForm
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("RESET")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_BCol, {
                              cols: "12",
                              lg: "4",
                              class: "pt-1 ps-lg-1",
                              order: "1",
                              "order-lg": "2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BButton, {
                                  class: "w-100",
                                  squared: "",
                                  variant: "success",
                                  onClick: _ctx.submitForm
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("SEND")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}